import React from "react"
import { StyleSheet, Text, TouchableOpacity } from "react-native"
import * as Animatable from "react-native-animatable"
import Icon from "react-native-vector-icons/Ionicons"

import Base from "../../base"

export default function VenueListItem(props) {
  let title = props.venue.name
  if (props.venue.externalVenueRef) {
    title += ` : ${props.venue.externalVenueRef}`
  }
  return (
    <Animatable.View
      style={styles.container}
      animation={"fadeIn"}
      delay={props.delay}
      duration={200}
    >
      <TouchableOpacity
        style={styles.main}
        onPress={() => props.onPress(props.venue)}
      >
        <Text style={styles.title}>{title}</Text>
        <Icon
          style={styles.icon}
          name="ios-arrow-forward"
          size={20}
          color={Base.colours.appRed}
        />
      </TouchableOpacity>
    </Animatable.View>
  )
}

const styles = StyleSheet.create({
  container: { flex: 0.5 },
  main: {
    flex: 1,
    flexDirection: "row",
    borderBottomColor: Base.colours.appSemiLightGrey,
    borderBottomWidth: 1,
  },

  title: {
    flex: 1,
    marginRight: 18,
    alignSelf: "center",
    fontSize: 16,
    color: Base.colours.appDarkBlue,
    fontFamily: Base.fonts.appExtraBold,
    marginVertical: 12,
  },

  icon: {
    marginHorizontal: 7,
    alignSelf: "center",
  },
})
